import React, { useEffect, useState } from "react";
import {
  Form,
  Typography,
  Flex,
  Grid,
  Radio,
  Button,
  Checkbox,
  Select,
  App,
  DatePicker,
  Drawer,
  Tooltip
} from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import InputField from "../../../../components/Input/Input";
import SearchAutoComplete from "../../../../components/SearchAutoComplete";
import InvoiceTable from "./InvoiceTable";
import {
  fetchCustomerList,
  fetchSalesAccounts,
  fetchDiscountAccounts,
  fetchTaxAccounts,
  fetchTransportAccounts,
  fetchCurrentStock,
  fetchSpecialPrices,
  fetchBatchesForItem,
  fetchPackingStructureForItem,
  fetchPendingSalesOrders,
} from "../../salesThunks";
import { fetchDeliveryRoutes } from "../../../Delivery/deliveryThunks";
import { selectDeliveryRoutes } from "../../../Delivery/deliverySelectors";
import { fetchQuotationWithDetails } from "../../../QuotationRecord/QuotationRecordThunk";
import { selectCustomersList } from "../../salesSelectors";
import {
  setResetSales,
  setSelectedCustomer,
  setTagFeildNameid,
  setEntryDate,
  clearSelectedSalesOrder,
  setIsTatmeenProduct,
  setSsccCode
} from "../../salesSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomersBalance } from "../../../Customers/customersThunks";
import { useForm } from "antd/es/form/Form";
import { useLocation, useNavigate } from "react-router-dom";
import { getCurrencyCodeWithName } from "../../../../lib/currency";
import { convertCurrency } from "../../../../utils";
import {
  fetchEmployees,
  fetchSingleInstitutionDetails,
  fetchTagGroupFields,
  fetchItems,
  fetchAccountsByType,
} from "../../../../store/commonThunks/lookups";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import dayjs from "dayjs";
import {
  getSalesOrderRecordWithDetailsApi,
  salesRecordWithDetailsApi,
} from "../../../../apiservice/sales";
import { fetchProductsList } from "../../../Products/productsThunks";
import { getAccessType, dateTimeFormat, formatToCompanyTimezone, accessChecker } from "../../../../lib/functions";
import {
  saveDraft,
  clearDraft,
} from "../../../../store/commonSlices/uiDraftsSlice";
import { selectDraft } from "../../../../store/commonSelectors/uiDraftsSelectors";
import CustomerDrawer from "../../../Customers/components/CustomerDrawer";
import EmployeeQuickDrawer from "../../../Employees/components/EmployeeQuickDrawer";
import { calculateTotals } from "../../../../utils/sale";
import { getTagForSales } from "../../../../services/sales";
import TagCreateForm from "../../../Settings/Tags/components/TagCreateForm";
import AddNewModal from "../../../../components/DropDown/AddNewModal";
import useMigrationDate from "../../../../hooks/useMigrationDate";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const vatAndTaxOptions = [
  { label: "Total Item", value: "on_total" },
  { label: "Individual Item", value: "individual" },
];

const CreateInvoiceForm = ({
  onSaveSales,
  prevDues,
  salesVoucherNumber,
  salesSuccess,
  authInfo,
  editId,
  convertId,
  quoteId,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = useForm();
  const { message } = App.useApp();

  const [taxMode, setTaxMode] = useState("individual");
  const [selectedSearchedCustomer, setSelectedSearchedCustomer] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(0);
  const [isConvertCurrencyShow, SetIsConvertCurrencyShow] = useState(false);
  const [selectedSalesAcc, SetSelectedSalesAcc] = useState(null);
  const [selectedServiceAcc, SetSelectedServiceAcc] = useState(null);
  const { loading, tag_field_id, entryDate, pendingSalesOrders, isTatmeenProduct, ssccCode } = useSelector(
    (state) => state.sales
  );

  const lookups = useSelector((state) => state.lookups);
  const [selectedTags, setSelectedTags] = useState([]);

  const screens = useBreakpoint();
  const [conversionRate, setConversionRate] = useState(null);
  const currency = authInfo?.currency || "AED";
  const [selectedDiscountAcc, selectedDiscountAccSet] = useState(null);
  const [selectedTaxAcc, setSelectedTaxAcc] = useState(null);
  const [selectedTransportAcc, setSelectedTransportAcc] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [customerDrawerOpen, setCustomerDrawerOpen] = useState(false);
  const [employeeDrawerOpen, setEmployeeDrawerOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [packingMap, setPackingMap] = useState({});
  const [batchMap, setBatchMap] = useState({});
  const [salesAccounts, setSalesAccounts] = useState([]);
  const [serviceAccounts, setServiceAccounts] = useState([]);
  const [tagModal, setTagModal] = useState(false);
  const [deliveryType, setDeliveryType] = useState(null);
  const [deliveryRouteId, setDeliveryRouteId] = useState(null);
  const [pickupDate, setPickupDate] = useState(null);
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [deliveryNotes, setDeliveryNotes] = useState("");

  const deliveryRoutes = useSelector(selectDeliveryRoutes);

  const [itemsList, setItemsList] = useState([
    {
      key: 1,
      product: null,
      quantity: null,
      rate: 0,
      discount: 0,
      vat: 0,
      vat_per: 0,
      total: 0,
      deliveryDate: "",

      batch_id: null,
      serial_mode: "unit",
      availableSerials: [],
      selectedSerials: [],
      child_sscc_code: "",
      is_tatmeen_required: false,
    },
  ]);

  const [footerValues, setFooterValues] = useState({
    discountPercent: 0,
    taxPercent: 0,
    serviceCharge: 0,
    paidAmount: 0,
    dueAmount: 0,
    subTotal: 0,
    description: "",
    challanText: "",
    emis: null,
    payCart: null,
    paymentMode: [],
    salesVoucherNumber: null,
  });

  let [access_type, access_type_set] = useState("");
  const location = useLocation();

  const DRAFT_KEY = "sales_entry_draft";
  const draft = useSelector((state) => selectDraft(state, DRAFT_KEY));

  const isFieldHidden = (fieldKey, pageKey = "sales_entry") => {
    return authInfo?.visibilitytabs?.some(
      (item) => item.page_key === pageKey && item.field_key === fieldKey
    );
  };

  const isTatmeenUAE =
    authInfo?.is_tatmeen_enabled === "yes" &&
    authInfo?.country === "United Arab Emirates" && (authInfo?.subscription == 'PharmaERP_Pro' || authInfo?.subscription == 'PharmaERP_Standard' || authInfo?.subscription == 'PharmaERP_Basic');

  const hasTatmeenEntryAccess = accessChecker("tatmeen_entry");

  const { disabledDate } = useMigrationDate();

  // ─── Restore draft ───────────────────────────────────────────────────────────
  useEffect(() => {
    if (!draft) return;

    if (draft.form) {
      const restored = { ...draft.form };
      if (restored.entry_date) {
        const d = dayjs(restored.entry_date);
        restored.entry_date = d.isValid() ? d : null;
      }
      form.setFieldsValue(restored);
    }
    dispatch(fetchCustomerList());
    dispatch(fetchProductsList());

    if (draft.extra) {
      setSelectedSearchedCustomer(draft.extra.selectedSearchedCustomer);
      setSelectedEmployee(draft.extra.selectedEmployee);
      setTaxMode(draft.extra.taxMode);
      setItemsList(draft.extra.itemsList);
      setFooterValues(draft.extra.footerValues);
      setConversionRate(draft.extra.conversionRate);
      setDueDate(draft.extra.dueDate);
      SetSelectedSalesAcc?.(draft.extra.selectedSalesAcc);
      selectedDiscountAccSet?.(draft.extra.selectedDiscountAcc);
      setSelectedTaxAcc?.(draft.extra.selectedTaxAcc);
      setSelectedTransportAcc?.(draft.extra.selectedTransportAcc);
      SetSelectedServiceAcc?.(draft.extra.selectedServiceAcc);
      dispatch(setTagFeildNameid(draft.extra.tag_field_id));
    }

    dispatch(clearDraft(DRAFT_KEY));
  }, []);

  useEffect(() => {
    const state = location.state;
    if (state?.newCustomerId && Array.isArray(selectCustomersList)) {
      const match = selectCustomersList.find((c) => c.acc_id == state.newCustomerId);
      if (match) {
        setSelectedSearchedCustomer(match);
        form.setFieldValue("search_customer", match);
        dispatch(fetchCustomersBalance(match.acc_id));
      }
    }
  }, [location.state, selectCustomersList]);

  useEffect(() => {
    const access = getAccessType("new_sales");
    access_type_set(access);
  }, []);

  // ─── Initial lookups ──────────────────────────────────────────────────────────
  useEffect(() => {
    dispatch(fetchItems(""));
    dispatch(fetchEmployees());
    dispatch(fetchTagGroupFields(""));
    dispatch(fetchDeliveryRoutes({}));

    dispatch(fetchSalesAccounts()).then((res) => {
      if (res?.payload) {
        const list = Array.isArray(res.payload) ? res.payload : [res.payload];
        setSalesAccounts(list);
        SetSelectedSalesAcc({ acc_id: list[0].acc_id, acc_name: list[0].acc_name });
      }
    });

    dispatch(fetchAccountsByType(["service_account"])).then((res) => {
      if (res?.payload) {
        const list = Array.isArray(res.payload) ? res.payload : [res.payload];
        setServiceAccounts(list);
        if (list[0]) {
          SetSelectedServiceAcc({ acc_id: list[0].acc_id, acc_name: list[0].acc_name });
        }
      }
    });

    dispatch(fetchDiscountAccounts()).then((res) => {
      if (res?.payload) selectedDiscountAccSet(res.payload);
    });

    dispatch(fetchTaxAccounts()).then((res) => {
      if (res?.payload) setSelectedTaxAcc(res.payload);
    });

    dispatch(fetchTransportAccounts()).then((res) => {
      if (res?.payload) setSelectedTransportAcc(res.payload);
    });
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchSingleInstitutionDetails());
  }, []);

  useEffect(() => {
    taxMode === "on_total" &&
      (authInfo?.country?.toLowerCase() !== "india" || authInfo?.gst_enabled === "yes")
      ? (footerValues.taxPercent = Number(lookups?.institutionData?.item_tax))
      : (footerValues.taxPercent = 0);
  }, [dispatch, footerValues, taxMode, authInfo]);

  useEffect(() => {
    const stored = sessionStorage.getItem("SO_TO_SALES_ITEMS");
    if (stored) {
      const parsedItems = JSON.parse(stored);
      setItemsList(parsedItems);
      sessionStorage.removeItem("SO_TO_SALES_ITEMS");
    }
  }, []);

  useEffect(() => {
    setFooterValues({ ...footerValues, salesVoucherNumber });
  }, [salesVoucherNumber]);

  // ─── Edit mode ────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (!editId) return;

    (async () => {
      try {
        const res = await salesRecordWithDetailsApi({ sale_id: editId, from: "voucher" });
        if (!res?.data?.length) return;

        const v = res.data[0];

        // Accounts
        if (v.sales_acc_id) SetSelectedSalesAcc({ acc_id: v.sales_acc_id, acc_name: v.sales_acc_name || "Sales" });
        if (v.discount_acc_id) selectedDiscountAccSet({ acc_id: v.discount_acc_id, acc_name: v.discount_acc_name || "Discount on sale" });
        if (v.tax_acc_id) setSelectedTaxAcc({ acc_id: v.tax_acc_id, acc_name: v.tax_acc_name || "duty and tax" });
        if (v.transport_acc_id) setSelectedTransportAcc({ acc_id: v.transport_acc_id, acc_name: v.transport_acc_name || "Transport Cost on Sales" });
        if (v.service_acc_id) SetSelectedServiceAcc({ acc_id: v.service_acc_id, acc_name: v.service_acc_name || "Services Account" });

        // Customer
        const customerObj = {
          acc_id: v.acc_id,
          acc_name: v.acc_name,
          contact_no: v.contact_no,
          institution_name: v.institution_name || "",
          address: v.address,
          acc_code: v.acc_code,
          display_text: v.display_text || `${v.acc_name} - ${v.acc_code}`,
        };
        setSelectedSearchedCustomer(customerObj);
        dispatch(setSelectedCustomer(customerObj));
        form.setFieldValue("search_customer", customerObj);
        if (v.acc_id) dispatch(fetchCustomersBalance(v.acc_id));

        let ssccCodeValue = "";
        if (v.sscc_code !== undefined && v.sscc_code !== null) {
          // If it's a boolean, convert to string
          ssccCodeValue = typeof v.sscc_code === 'string' ? v.sscc_code : String(v.sscc_code);
          // If it's "true" or "false" strings, convert appropriately
          if (ssccCodeValue === "true") ssccCodeValue = "";
          if (ssccCodeValue === "false") ssccCodeValue = "";
        } else {
          ssccCodeValue = "";
        }


        dispatch(setSsccCode(ssccCodeValue));
        form.setFieldValue("sscc_code", ssccCodeValue);

        // ✅ Fix Tatmeen Product flag
        const tatmeenValue = v.is_tatmeen_product === 1 ||
          v.is_tatmeen_product === "1" ||
          v.is_tatmeen_product === true;
        dispatch(setIsTatmeenProduct(tatmeenValue));

        // Employee
        if (v.employee_id && v.employee_id > 0) {
          setSelectedEmployee(v.employee_id);
          await dispatch(fetchEmployees()).unwrap();
          const employees = lookups.employees || [];
          const employee = employees.find((e) => e.employee_id === v.employee_id);
          if (employee) {
            form.setFieldValue("employee_id", {
              sale_id: v.employee_id,
              display_text: employee.employee_name,
            });
          }
        }

        // Entry Date
        if (v.created_date) {
          const isoDate = dayjs(v.created_date).toISOString();
          dispatch(setEntryDate(isoDate));
          form.setFieldValue("entry_date", dayjs(isoDate));
        }

        // Tags
        try {
          const tagsResponse = await getTagForSales({ tab_id: editId, type: "sales_entry" });
          if (tagsResponse?.data?.data?.length > 0) {
            const formattedTags = tagsResponse.data.data.map((item) => ({
              id: item.tag_field_id,
              display_text: `${item.group_name}/${item.display_text}`,
            }));
            const tagOptions = formattedTags.map((item) => ({
              label: item.display_text,
              value: item.display_text,
              tagid: item.id,
            }));
            setSelectedTags(tagOptions.map((t) => t.value));
            dispatch(setTagFeildNameid(tagOptions.map((t) => t.tagid)));
          }
        } catch (tagError) {
          console.error("Failed to load tags for sale:", tagError);
        }

        // Items
        const itemsWithData = await Promise.all(
          (v.details || []).map(async (d, index) => {
            const isBonus =
              parseFloat(d.item_rate) === 0 ||
              parseFloat(d.item_qty) === 0 ||
              d.is_bonus === "yes" ||
              d.is_bonus === 1 ||
              d.is_bonus === true;

            let finalRate = isBonus ? 0 : parseFloat(d.item_rate);

            if (!isBonus && v.acc_id && parseFloat(d.item_rate) > 0) {
              try {
                const specialPriceRes = await dispatch(
                  fetchSpecialPrices({ item_id: d.item_id, account_id: v.acc_id })
                ).unwrap();
                if (specialPriceRes?.length > 0 && specialPriceRes[0]?.price) {
                  finalRate = parseFloat(specialPriceRes[0].price);
                }
              } catch (err) {
                console.error("Failed to load special price:", err);
              }
            }

            let itemInfo = null;
            if (!isBonus) {
              try {
                const stockRes = await dispatch(
                  fetchCurrentStock({ itemId: d.item_id, warehouseId: 0 })
                ).unwrap();
                itemInfo = stockRes || null;
              } catch (err) {
                console.error("Failed to load stock for item:", d.item_id, err);
              }
            }

            // Packing
            let packingData = [];
            let packing_name = null;
            let packing_quantity = null;
            let packing_name_quantity = null;

            if (d.pack_type && d.pack_defined_qty && d.pack_qty) {
              packing_name = d.pack_type;
              packing_name_quantity = parseFloat(d.pack_defined_qty);
              packing_quantity = parseFloat(d.pack_qty);
              packingData = [{ name: d.pack_type, qty: parseFloat(d.pack_defined_qty), product_id: d.item_id }];
              try {
                const packingRes = await dispatch(fetchPackingStructureForItem({ product_id: d.item_id })).unwrap();
                if (packingRes?.length > 0) {
                  packingData = packingRes;
                  setPackingMap((prev) => ({ ...prev, [d.item_id]: packingRes }));
                }
              } catch (err) {
                console.error("Failed to load packing structure:", err);
              }
            } else {
              try {
                const packingRes = await dispatch(fetchPackingStructureForItem({ product_id: d.item_id })).unwrap();
                packingData = packingRes || [];
                setPackingMap((prev) => ({ ...prev, [d.item_id]: packingRes || [] }));
              } catch (err) {
                console.error("Failed to load packing structure:", err);
              }
            }

            // Batch
            let batchData = [];
            let batch_name = d.batch_name || null;
            let batch_id = d.batch_id || null;
            let batch_expiry = d.batch_expiry || null;

            if (d.batch_id && d.batch_name) {
              batchData.push({
                id: d.batch_id,
                batch_name: d.batch_name,
                batch_expiry: d.batch_expiry,
                quantity: d.item_qty,
                serial_mode: d.serial_mode || "unit"
              });
            }

            // ✅ Then fetch all available batches
            if (!isBonus && d.item_id && parseFloat(d.item_qty) > 0) {
              try {
                const batchRes = await dispatch(
                  fetchBatchesForItem({
                    item_id: d.item_id,
                    item_qty: parseFloat(d.item_qty) || 0,
                  })
                ).unwrap();

                // ✅ Merge batches, avoiding duplicates
                const existingIds = new Set(batchData.map(b => b.id));
                const additionalBatches = (batchRes || []).filter(b => !existingIds.has(b.id));
                batchData = [...batchData, ...additionalBatches];

                // ✅ Update batchMap IMMEDIATELY
                setBatchMap(prev => ({
                  ...prev,
                  [d.item_id]: batchData
                }));
              } catch (err) {
                console.error("Failed to load batches:", err);
              }
            } else {
              // ✅ If no batch in API, still fetch available batches for dropdown
              if (!isBonus && d.item_id && parseFloat(d.item_qty) > 0) {
                try {
                  const batchRes = await dispatch(
                    fetchBatchesForItem({
                      item_id: d.item_id,
                      item_qty: parseFloat(d.item_qty) || 0,
                    })
                  ).unwrap();
                  batchData = batchRes || [];
                  setBatchMap(prev => ({
                    ...prev,
                    [d.item_id]: batchRes || []
                  }));
                } catch (err) {
                  console.error("Failed to load batches:", err);
                }
              }
            }


            return {
              key: index + 1,
              product: {
                item_id: d.item_id,
                item_name: d.item_name,
                display_text: d.display_text || d.item_name,
                tax_per: parseFloat(d.item_tax_per) || 0,
                item_rate: parseFloat(d.item_rate),
                sale_rate: parseFloat(d.sale_rate),
                // ✅ Carry moh_invoice_rate for bonus/MOH logic
                moh_invoice_rate: parseFloat(d.moh_invoice_rate) || 0,
                unit_name: d.unit_name,
                unit_symbol: d.unit_symbol,
                unit_id: d.unit_id,
                conversion: parseFloat(d.conversion) || 1,
                base_unit_name: d.base_unit_name,
                is_serial: d.is_serial,
                is_service: d.is_service,
                units: d.units || [],
                sale_d_id: d.sale_d_id || null,
              },
              sale_d_id: d.sale_d_id || null,
              item_description: d?.item_description || "",
              showDescription: !!d?.item_description || false,
              quantity: parseFloat(d.item_qty) || 0,
              ordered_qty: parseFloat(d.item_qty) || 0,
              rate: finalRate,
              discount_per: parseFloat(d.item_discount_per) || 0,
              discount: parseFloat(d.item_discount) || 0,
              discount_amt: parseFloat(d.item_discount) || 0,
              discountMode: d.discount_mode || "percent",
              vat_per: parseFloat(d.item_tax_per) || 0,
              vat: parseFloat(d.item_tax) || 0,
              total: parseFloat(d.item_total) || 0,
              bonus: isBonus,
              itemInfo,
              unit_id: d.unit_id,
              per_unit_id: d.per_unit_id,
              per_unit_symbol: d.per_unit_symbol,
              per_conversion: parseFloat(d.per_conversion) || 1,
              batch_id,
              batch_name,
              batch_expiry,
              packing_name,
              packing_quantity,
              packing_name_quantity,
              packing_options: packingData,
              batches: batchData,
              serial_mode: d.serial_mode || "unit",
              availableSerials: d.availableSerials || [], // ✅ Use API data
              selectedSerials: d.serials
                ? d.serials.split(",").filter(Boolean)
                : [],
              is_tatmeen_required: d.is_tatmeen_required === 1 ||
                d.is_tatmeen_required === "1" ||
                d.is_tatmeen_required === true,
              child_sscc_code: d.child_sscc_code || "",
            };
          })
        );

        setItemsList(itemsWithData);

        // Payment data
        const payCart = (v.trans || []).map((t, idx) => {
          let acc_type_id = "cash_in_hand";
          if (t.to_acc_name?.toLowerCase().includes("cash")) acc_type_id = "cash_in_hand";
          else if (t.to_acc_name?.toLowerCase().includes("pdc") || t.to_acc_name?.toLowerCase().includes("cdc")) acc_type_id = "cheque";
          else acc_type_id = "bank_account";

          return {
            key: t.to_acc_name || `payment_${idx}`,
            type: t.to_acc_name,
            to_acc_name: t.to_acc_name,
            tran_amount: parseFloat(t.tran_amount) || 0,
            date: t.date || t.tran_date || v.created_date,
            from_acc_id: t.from_acc_id || t.to_acc_id,
            from_acc_name: t.from_acc_name || t.to_acc_name,
            to_acc_id: t.to_acc_id,
            acc_type_id,
          };
        });

        const payServiceCart = (v.otherServiceTrans || []).map((t, idx) => ({
          key: `expense_${idx}`,
          type: t.to_acc_name,
          to_acc_name: t.to_acc_name,
          tran_amount: parseFloat(t.tran_amount) || 0,
          date: t.tran_date || v.created_date,
          to_acc_id: t.to_acc_id,
          acc_type_id: t.acc_type_id || "direct_income",
        }));

        const paymentMode = [];
        if (payCart.length > 0) paymentMode.push("isCheque");
        if (v.is_emi === "yes" || (v.emis && v.emis.length > 0)) paymentMode.push("isEmi");
        if (payServiceCart.length > 0 || v.other_service_cost > 0) paymentMode.push("addExpenses");

        const { totalSubtotal, grandTotal, dueAmount: calculatedDueAmount } = calculateTotals(
          v.is_cal_type === "individual" ? "individual" : "on_total",
          itemsWithData,
          {
            discountPercent: parseFloat(v.total_discount_per) || 0,
            taxPercent: parseFloat(v.total_tax_per) || 0,
            paidAmount: parseFloat(v.paid_amount) || 0,
            payServiceCart,
          }
        );

        const emiData = (v.emis || []).map((emi, index) => ({
          emiNo: emi.emi_no || `${index + 1}-${v.sale_voucher_no}`,
          fromDate: emi.from_date,
          lastPayDate: emi.last_date,
          amount: parseFloat(emi.amount) || 0,
        }));

        const emiAmount =
          v.emis?.length > 0
            ? parseFloat(v.emis[0]?.amount) || parseFloat(v.emi_amount) || 0
            : parseFloat(v.emi_amount) || 0;

        setFooterValues({
          description: v.narration || "",
          challanText: v.challan_text || "",
          paidAmount: parseFloat(v.paid_amount) || 0,
          paid_amount: parseFloat(v.paid_amount) || 0,
          dueAmount: calculatedDueAmount || parseFloat(v.due_amount) || 0,
          subTotal: totalSubtotal || parseFloat(v.sub_total) || 0,
          discountPercent: parseFloat(v.total_discount_per) || 0,
          discountMode: v.total_discount_mode || "percent",
          taxPercent: parseFloat(v.total_tax_per) || 0,
          serviceCharge: parseFloat(v.other_service_cost) || 0,
          payCart,
          payServiceCart,
          paymentMode,
          emis: emiData,
          emiMonths: v.emi_month || (v.emis ? v.emis.length : 0),
          dayWeek: v.day_week || "0",
          emiAmount,
          emiDayWeek: v.day_week || "0",
          salesVoucherNumber: v.sale_voucher_no,
          dueDate: v.due_date ? dayjs(v.due_date).format("DD-MM-YYYY") : "",
          conversion_rate: parseFloat(v.conversion_rate) || 0,
          conversion_currency: v.conversion_currency || "",
        });

        if (v.due_date) {
          const dueDateFormatted = dayjs(v.due_date).format("DD-MM-YYYY");
          setDueDate(dueDateFormatted);
          handleFooterChange(dueDateFormatted, "dueDate");
        }

        setTaxMode(v.is_cal_type === "individual" ? "individual" : "on_total");

        if (v.conversion_rate && parseFloat(v.conversion_rate) > 0) {
          setConversionRate(parseFloat(v.conversion_rate));
          SetIsConvertCurrencyShow(true);
        }

        if (v.is_emi === "yes" && v.emi_month > 0) {
          form.setFieldValue("emiMonths", v.emi_month);
          form.setFieldValue("dayWeek", v.day_week);
          form.setFieldValue("amount", v.emi_amount);
        }
      } catch (error) {
        console.error("Edit Load Failed:", error);
        message.error("Failed to load sales data for editing");
      }
    })();
  }, [editId, dispatch, form]);

  // ─── Sales Order conversion ───────────────────────────────────────────────────
  useEffect(() => {
    if (!convertId) return;
    let isMounted = true;

    async function loadOrder() {
      const res = await getSalesOrderRecordWithDetailsApi({ sale_o_id: convertId });
      const order = res.data[0];

      if (!order || !isMounted) return;

      if (order.status === "converted") {
        message.error("This Sales Order is already fully converted.");
        navigate("/sales");
        return;
      }

      if (!selectedSearchedCustomer) {
        const customerObj = {
          acc_code: order?.acc_code,
          acc_id: order?.acc_id,
          acc_name: order?.acc_name,
          acc_type_id: order?.acc_type_id || 0,
          acc_type_name: order?.acc_type_name || "",
          address: order?.address,
          contact_no: order?.contact_no,
          country_code: order?.country_code || "1",
          credit_day: order?.credit_day || null,
          credit_limit: order?.credit_limit || 0,
          credit_month: order?.credit_month || "",
          display_text: order?.acc_name,
          employee_id: order?.employee_id || 0,
          group_name: order?.group_name || null,
          institution_name: order?.institution_name,
          party_type: order?.party_type || "",
        };
        handleSelect(customerObj);
        dispatch(setSelectedCustomer(customerObj));
        form.setFieldValue("search_customer", customerObj);
      }

      // ✅ Map items with bonus detection same as Sales Pharma (rate 0 = bonus + moh_invoice_rate)
      const mappedItems = await Promise.all(
        order.details.map(async (item, index) => {
          const orderedQty = Number(item.item_qty);
          const convertedQty = Number(item.converted_qty || 0);
          const remainingQty = orderedQty - convertedQty;
          if (remainingQty <= 0) return null;

          // ✅ Same bonus detection as Sales Pharma
          const isBonus = parseFloat(item.item_rate) === 0;

          let itemInfo = null;
          try {
            const stockRes = await dispatch(
              fetchCurrentStock({ itemId: item.item_id, warehouseId: 0 })
            ).unwrap();
            itemInfo = stockRes || null;
          } catch (err) {
            console.error("Failed stock fetch:", err);
          }

          return {
            key: index + 1,
            product: {
              item_id: item.item_id,
              item_name: item.item_name,
              display_text: item.item_name,
              tax_per: parseFloat(item.item_tax_per) || 0,
              item_rate: parseFloat(item.item_rate),
              sale_rate: isBonus ? 0 : parseFloat(item.item_rate),
              // ✅ Carry moh_invoice_rate
              moh_invoice_rate: parseFloat(item.moh_invoice_rate) || 0,
              unit_name: item.unit_name,
              unit_symbol: item.unit_symbol,
              unit_id: item.unit_id,
              conversion: parseFloat(item.conversion) || 1,
              base_unit_name: item.base_unit_name,
              is_serial: item.is_serial,
              is_service: item.is_service,
              units: item.units || [],
            },
            quantity: remainingQty,
            ordered_qty: orderedQty,
            itemInfo,
            rate: isBonus ? 0 : parseFloat(item.item_rate),
            discount: parseFloat(item.item_discount) || 0,
            discount_per: parseFloat(item.item_discount_per) || 0,
            discount_amt: parseFloat(item.item_discount) || 0,
            discountMode: item.discount_mode || "percent",
            item_description: item?.item_description || "",
            showDescription: !!item?.item_description,
            vat: isBonus
              ? 0
              : (remainingQty * parseFloat(item.item_rate) -
                (parseFloat(item.item_discount_per) / 100) *
                remainingQty *
                parseFloat(item.item_rate)) *
              (parseFloat(item.item_tax_per) / 100),
            vat_per: parseFloat(item.item_tax_per) || 0,
            bonus: isBonus,
            batch_id: null,
            serial_mode: "unit",
            availableSerials: [],
            selectedSerials: [],
          };
        })
      );

      if (!isMounted) return;
      const finalItems = mappedItems.filter(Boolean);

      if (finalItems.length === 0) {
        message.warning("No remaining quantity to convert.");
        navigate("/sales");
        return;
      }

      // ✅ Enrich with full product data — DO NOT fetchProductsList (overwrites moh_invoice_rate)
      const enrichedItems = finalItems.map((finalItem) => {
        const orderItem = order.details.find(
          (d) => d.item_id === finalItem.product?.item_id
        );
        if (!orderItem) return finalItem;

        return {
          ...finalItem,
          product: {
            item_id: orderItem.item_id,
            item_name: orderItem.item_name,
            display_text: orderItem.item_name,
            tax_per: parseFloat(orderItem.item_tax_per) || 0,
            item_rate: parseFloat(orderItem.item_rate),
            sale_rate: parseFloat(orderItem.sale_rate) || 0,
            // ✅ Keep moh_invoice_rate
            moh_invoice_rate: parseFloat(orderItem.moh_invoice_rate) || 0,
            unit_name: orderItem.unit_name,
            unit_symbol: orderItem.unit_symbol,
            unit_id: orderItem.unit_id,
            conversion: parseFloat(orderItem.conversion) || 1,
            base_unit_name: orderItem.base_unit_name,
            is_serial: orderItem.is_serial,
            is_service: orderItem.is_service,
            units: orderItem.units || [],
          },
        };
      });

      setItemsList(enrichedItems);

      const payServiceCart = (order.otherServiceTrans || []).map((t, idx) => ({
        key: `expense_${idx}`,
        type: t.to_acc_name,
        to_acc_name: t.to_acc_name,
        tran_amount: parseFloat(t.tran_amount) || 0,
        to_acc_id: t.to_acc_id,
        from_acc_id: order.acc_id,
        acc_type_id: t.acc_type_id || "direct_income",
      }));

      const serviceCharge = payServiceCart.reduce(
        (sum, item) => sum + parseFloat(item.tran_amount || 0),
        0
      );

      setTaxMode(order.is_cal_type === "individual" ? "individual" : "on_total");

      setFooterValues((prev) => ({
        ...prev,
        description: order.narration || "",
        serviceCharge,
        payServiceCart,
        paymentMode: payServiceCart.length > 0 ? ["addExpenses"] : [],
      }));
    }

    loadOrder();
    return () => { isMounted = false; };
  }, [convertId]);

  // ─── Quotation to Sales ───────────────────────────────────────────────────────
  useEffect(() => {
    if (!quoteId) return;

    const loadQuotation = async () => {
      try {
        const res = await dispatch(fetchQuotationWithDetails(quoteId)).unwrap();
        const q = res[0];

        const customerObj = {
          acc_code: q?.acc_code,
          acc_id: q.acc_id,
          acc_name: q.acc_name,
          acc_type_id: q?.acc_type_id || 0,
          acc_type_name: q?.acc_type_name || "",
          address: q.address,
          contact_no: q.contact_no,
          country_code: q?.country_code || "1",
          credit_day: q?.credit_day || null,
          credit_limit: q?.credit_limit || 0,
          credit_month: q?.credit_month || "",
          display_text: `${q.acc_name} - ${q.acc_code}`,
          employee_id: q?.employee_id || 0,
          group_name: q?.group_name || null,
          institution_name: q.institution_name,
          party_type: q?.party_type || "",
        };

        form.setFieldValue("search_customer", customerObj);
        handleSelect(customerObj);

        // ✅ Map items matching Sales Pharma pattern with moh_invoice_rate
        const mappedItems = await Promise.all(
          q?.details.map(async (d, index) => {
            const stockRes = await dispatch(
              fetchCurrentStock({ itemId: d.item_id, warehouseId: 0 })
            ).unwrap();

            const isBonus =
              d.is_bonus === 1 ||
              d.is_bonus === "yes" ||
              d.is_bonus === true ||
              parseFloat(d.item_rate) === 0;

            // ✅ Fetch full product metadata (same as Sales Pharma)
            let fullProduct = null;
            try {
              const productFullList = await dispatch(
                fetchProductsList({ query: d.item_name, search: false, partyType: "general", includeServices: true })
              ).unwrap();
              fullProduct = productFullList.find((p) => p.item_id === d.item_id);
            } catch (err) {
              console.error("Failed to fetch product metadata:", err);
            }

            const quotationRate = parseFloat(d.item_rate) || 0;

            return {
              key: index + 1,
              product: {
                // ✅ Spread full product metadata first (units, tax_per, etc.)
                ...(fullProduct || {}),
                // ✅ Override rates with quotation values — never let master overwrite
                item_id: d.item_id,
                item_name: d.item_name,
                display_text: d.item_name,
                tax_per: d.item_tax_per,
                item_rate: quotationRate,
                sale_rate: quotationRate,
                // ✅ moh_invoice_rate so bonus useEffect uses it
                moh_invoice_rate: quotationRate,
              },
              quantity: d.item_qty,
              itemInfo: stockRes || null,
              rate: isBonus ? 0 : quotationRate,
              discount_per: d.item_discount_per,
              discount_amt: d.item_discount || 0,
              discountMode: d.discount_mode || "percent",
              item_description: d?.item_description || "",
              showDescription: !!d?.item_description,
              vat: isBonus
                ? 0
                : (d.item_qty * quotationRate -
                  (d.item_discount_per / 100) * d.item_qty * quotationRate) *
                (d.item_tax_per / 100),
              vat_per: d.item_tax_per,
              bonus: isBonus,
            };
          })
        );

        setItemsList(mappedItems);

        const payServiceCart = (q.otherServiceTrans || []).map((t, idx) => ({
          key: `expense_${idx}`,
          type: t.to_acc_name,
          to_acc_name: t.to_acc_name,
          tran_amount: parseFloat(t.tran_amount) || 0,
          to_acc_id: t.to_acc_id,
          from_acc_id: q.acc_id,
          acc_type_id: t.acc_type_id || "direct_income",
        }));

        setFooterValues((prev) => ({
          ...prev,
          description: q.narration || "",
          serviceCharge: 0,
          payServiceCart,
          addExpenses: payServiceCart.length > 0,
          paymentMode: payServiceCart.length > 0 ? ["addExpenses"] : [],
        }));

        // ✅ "on_total" consistent with Sales Pharma
        setTaxMode(q.is_cal_type === "on_total" ? "on_total" : "individual");

        let computedDueDate = null;
        if (customerObj.credit_day != null) {
          computedDueDate = dayjs().add(customerObj.credit_day, "day").format("DD-MM-YYYY");
        } else if (customerObj.credit_month != null) {
          const today = new Date();
          let year = today.getFullYear();
          let month = today.getMonth() + customerObj.credit_month;
          while (month > 11) { month -= 12; year++; }
          const lastDay = new Date(year, month + 1, 0).getDate();
          computedDueDate = dayjs(new Date(year, month, lastDay)).format("DD-MM-YYYY");
        }

        if (computedDueDate) {
          setDueDate(computedDueDate);
          handleFooterChange(computedDueDate, "dueDate");
        }
      } catch (error) {
        console.log("Failed to load quotation:", error);
      }
    };

    loadQuotation();
  }, [quoteId, dispatch, form]);

  // ─── Reset after save ─────────────────────────────────────────────────────────
  useEffect(() => {
    if (salesSuccess?.message) {
      form.resetFields();
      setItemsList([{
        key: 1, product: null, item_description: "", showDescription: false, itemInfo: null, quantity: 0,
        discount_per: 0, rate: 0, vat: 0, vat_per: 0,
        total: 0, deliveryDate: "", bonus: false, batch_id: null,
        serial_mode: "unit",
        availableSerials: [],
        selectedSerials: [],
        child_sscc_code: "",
      }]);
      setFooterValues({
        discountPercent: 0, taxPercent: 0, serviceCharge: 0,
        paidAmount: 0, dueAmount: 0, subTotal: 0,
        description: "", challanText: "", emis: null,
        payCart: null, paymentMode: [], salesVoucherNumber: null,
        rate: 0, toCurrency: "", dueDate: "",
      });
      setSelectedSearchedCustomer(null);
      setSelectedEmployee(0);
      SetIsConvertCurrencyShow(false);
      setConversionRate(0);
      setDueDate(null);
      dispatch(setResetSales());
    }
  }, [salesSuccess]);

  // ─── Handlers ────────────────────────────────────────────────────────────────
  const handleAddRow = () => {
    setItemsList([
      ...itemsList,
      {
        key: itemsList.length + 1, product: "", item_description: "", showDescription: false, quantity: 0, rate: 0, discount: 0, discount_per: 0, discount_amt: null, discountMode: "percent", vat: 0, total: 0, deliveryDate: null, batch_id: null,
        serial_mode: "unit",
        availableSerials: [],
        selectedSerials: [],
        is_tatmeen_required: false,
        child_sscc_code: "",
      },
    ]);
  };

  const handletaggroup = (values, selectedOptions) => {
    setSelectedTags(values);
    const tagIds = selectedOptions?.map((opt) => opt.tagid) || [];
    dispatch(setTagFeildNameid(tagIds));
  };

  const handleDeleteRow = (key) => {
    setItemsList(itemsList.filter((item) => item.key !== key));
  };

  const handleInputChange = (value, key, field) => {
    const newDataSource = [...itemsList];
    const rowIndex = newDataSource.findIndex((item) => item.key === key);
    const record = newDataSource[rowIndex];

    if (convertId && field === "quantity") {
      if (value > record.ordered_qty) {
        message.warning(`Max allowed quantity is ${record.ordered_qty}`);
        value = record.ordered_qty;
      }
    }

    record[field] = value;
    setItemsList(newDataSource);
  };

  const handleFooterChange = (value, field) => {
    setFooterValues((prev) => {
      if (field === "payCart") {
        const newPaidAmount = value
          .filter((item) => item.acc_type_id !== "cheque")
          .reduce((sum, item) => sum + parseFloat(item.tran_amount || 0), 0);

        return { ...prev, payCart: value, paid_amount: newPaidAmount, paidAmount: newPaidAmount };
      }
      return { ...prev, [field]: value };
    });
  };

  const refreshTotals = (mode = taxMode) => {
    const totals = calculateTotals(mode, itemsList, footerValues);
    setFooterValues((prev) => ({ ...prev, ...totals }));
  };

  const handleSelect = (customer) => {
    if (customer === "add_new") {
      setCustomerDrawerOpen(true);
      return;
    }

    if (customer) {
      setSelectedSearchedCustomer(customer);
      form.setFieldValue("search_customer", customer);
      dispatch(fetchCustomersBalance(customer?.acc_id));
      dispatch(fetchPendingSalesOrders({ acc_id: customer.acc_id }));

      const today = new Date();
      let year = today.getFullYear();
      let month = today.getMonth();
      let dueDate = null;

      if (customer.credit_day != null) {
        const newDate = dayjs().add(parseInt(customer.credit_day, 10) || 0, "day").format("DD-MM-YYYY");
        setDueDate(newDate);
      } else if (customer.credit_month != null) {
        let targetMonth = parseInt(month) + parseInt(customer.credit_month);
        while (targetMonth > 11) { targetMonth -= 12; year += 1; }
        const lastMonthDays = new Date(year, targetMonth + 1, 0).getDate();
        dueDate = dayjs(new Date(year, targetMonth, lastMonthDays)).format("DD-MM-YYYY");
        setDueDate(dueDate);
        handleFooterChange(dueDate, "dueDate");
      }

      // Auto-populate delivery route from customer's default, only when not direct_sales
      if (customer.default_delivery_route_id && deliveryType !== "direct_sales") {
        setDeliveryRouteId(customer.default_delivery_route_id);
        if (!deliveryType) setDeliveryType("onsite_delivery");
      }
    } else {
      form.setFieldValue("search_customer", null);
      dispatch(clearSelectedSalesOrder());
    }
  };

  const submitForm = async () => {
    try {
      await form.validateFields();

      setItemsList((prev) => prev.filter((row) => row.product && row.product.item_id));

      onSaveSales(
        selectedSearchedCustomer,
        itemsList,
        footerValues,
        taxMode,
        selectedEmployee,
        selectedSalesAcc,
        selectedDiscountAcc,
        selectedTaxAcc,
        selectedTransportAcc,
        {
          delivery_type: deliveryType,
          delivery_route_id: deliveryRouteId,
          pickup_date: pickupDate,
          delivery_date: deliveryDate,
          delivery_notes: deliveryNotes || null,
        },
        selectedServiceAcc
      );
    } catch (error) {
      console.log(error);
    }
  };

  // ─── Draft helpers ────────────────────────────────────────────────────────────
  const isSerializable = (val) => {
    if (typeof val === "number" || typeof val === "string" || typeof val === "boolean" || val === null) return true;
    if (Array.isArray(val)) return true;
    if (val && typeof val === "object") return true;
    return false;
  };

  const deepClone = (val) => {
    if (!isSerializable(val)) return null;
    if (Array.isArray(val)) return val.map(deepClone);
    if (val instanceof dayjs) return val.format("DD-MM-YYYY");
    if (typeof val === "object") {
      const obj = {};
      for (const key in val) obj[key] = deepClone(val[key]);
      return obj;
    }
    return val;
  };

  const sanitizeForRedux = (obj) => {
    const clone = deepClone(obj);
    return JSON.parse(JSON.stringify(clone));
  };

  const handleSaveDraftAndNavigate = (navigateTo) => {
    const formValues = form.getFieldsValue(true);
    const extra = {
      selectedSearchedCustomer, selectedEmployee, taxMode,
      itemsList, footerValues, conversionRate, dueDate,
      selectedSalesAcc, selectedDiscountAcc, selectedTaxAcc,
      selectedTransportAcc, tag_field_id, selectedServiceAcc,
    };
    const sanitized = sanitizeForRedux({ form: formValues, extra });
    dispatch(saveDraft({ key: DRAFT_KEY, data: sanitized }));
    navigate(`${navigateTo}?returnUrl=${location.pathname}`);
  };

  let tags = lookups.tagFields.map((tag) => ({
    label: tag.display_text,
    value: tag.id,
    tagid: tag.id,
  })) || [];

  const hasServiceItems = itemsList?.some((item) => item.product?.is_service === "yes");

  // ─── Render ───────────────────────────────────────────────────────────────────
  return (
    <div className="invoice-form">
      <Flex justify="space-between" align="center" style={{ marginBottom: "32px" }}>
        <Title level={2} style={{ margin: 0 }}>
          {convertId ? "Order to Sales Conversion" : quoteId ? "Quotation to Sales Conversion" : "Sales"}
        </Title>
        <Tooltip title="Help">
          <Button type="text" icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />} onClick={() => setHelpOpen(true)} />
        </Tooltip>
      </Flex>

      <Form
        form={form}
        layout="horizontal"
        style={{ width: "100%", maxWidth: "1200px" }}
        colon={false}
        labelCol={{ span: 8 }}
        initialValues={{ entry_date: dayjs(entryDate) }}
        wrapperCol={{ span: 18 }}
      >
        {/* Top action buttons */}
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="flex-start"
          style={{ flexDirection: !screens.md || !screens.xl ? "column" : "row", width: "100%", marginBottom: "24px" }}
        >
          {!screens.xs && (
            <Flex gap={16}>
              <Button size="large" className="traic-button" onClick={() => navigate(-1)}>Back</Button>
              {access_type === "WRITE" && (
                <Button type="primary" size="large" className="traic-button" onClick={submitForm} loading={loading}>Save</Button>
              )}
            </Flex>
          )}
        </Flex>

        {/* Two Column Form */}
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{ flexDirection: !screens.md || !screens.xl ? "column" : "row", width: "100%", marginBottom: "24px" }}
        >
          {/* Left Column */}
          <Flex vertical gap={10} style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}>
            <Form.Item
              label={<span>Search Customer</span>}
              name="search_customer"
              rules={[{ required: true, message: "Select customer" }]}
            >
              <SearchAutoComplete
                searchThunk={(searchText) => dispatch(fetchCustomerList(searchText))}
                resultSelector={selectCustomersList}
                value={selectedSearchedCustomer}
                onSelect={handleSelect}
                placeholder="Customer"
              />
            </Form.Item>

            {!convertId && !quoteId && (
              <Form.Item label="Convert From Sales Order">
                <SearchListAutoComplete
                  entityType="sales_order"
                  placeholder="Sales Order"
                  optionsList={pendingSalesOrders.map((o) => ({
                    sale_id: o.sale_o_id,
                    display_text: `${o.sale_order_no} - ${formatToCompanyTimezone(o.created_date)}`,
                    raw: o,
                  }))}
                  disabled={!selectedSearchedCustomer}
                  onSelect={(val) => {
                    if (!val?.sale_id) return;
                    navigate(`/invoice?convert_from_sale_order=${val.sale_id}`);
                  }}
                />
              </Form.Item>
            )}

            <Form.Item label="Customer name">
              <InputField value={selectedSearchedCustomer?.acc_name} disabled />
            </Form.Item>

            <Form.Item label="Institution Name">
              <InputField value={selectedSearchedCustomer?.institution_name} disabled />
            </Form.Item>

            <Form.Item label="Customer Address">
              <InputField value={selectedSearchedCustomer?.address} disabled />
            </Form.Item>

            <Form.Item label="Entry Date" rules={[{ required: true, message: "Please select date" }]}>
              <DatePicker
                style={{ width: "100%" }}
                value={entryDate ? dayjs(entryDate) : null}
                onChange={(d) => dispatch(setEntryDate(d ? d.toISOString() : null))}
                disabledDate={disabledDate}
                format={dateTimeFormat}
              />
            </Form.Item>

            <Form.Item label="Discount">
              <Radio.Group
                options={[
                  { label: "On Total", value: "on_total" },
                  { label: "On Individual Item", value: "individual" },
                ]}
                onChange={(e) => {
                  const mode = e.target.value;
                  setTaxMode(mode);
                  refreshTotals(mode);
                }}
                value={taxMode}
              />
            </Form.Item>

            {isTatmeenUAE && hasTatmeenEntryAccess && (
              <>
                <Form.Item
                  label="sscc code"
                  name="sscc_code"
                  style={{ marginBottom: 0 }}
                >
                  <InputField
                    placeholder="Enter SSCC Code"
                    value={ssccCode}
                    onChange={(e) =>
                      dispatch(setSsccCode(e.target.value))
                    }
                    style={{
                      borderColor: isTatmeenProduct && !ssccCode ? '#ff4d4f' : undefined
                    }}
                  />
                </Form.Item>

                <Form.Item
                  name="is_tatmeen_product"
                  valuePropName="checked"
                  style={{ marginBottom: 0 }}
                >
                  <Checkbox
                    checked={isTatmeenProduct}
                    disabled={!!editId}
                    onChange={(e) =>
                      dispatch(setIsTatmeenProduct(e.target.checked))
                    }
                  >
                    Tatmeen Product
                  </Checkbox>
                </Form.Item>
              </>
            )}
          </Flex>

          {/* Right Column */}
          <Flex vertical gap={10} style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}>
            <Form.Item label="Sales Account">
              <Select
                showSearch
                placeholder="Select Sales Account"
                optionFilterProp="label"
                value={selectedSalesAcc?.acc_id}
                options={salesAccounts.map((a) => ({ label: a.acc_name, value: a.acc_id }))}
                onChange={(val) => {
                  const acc = salesAccounts.find((a) => a.acc_id === val);
                  SetSelectedSalesAcc(acc);
                }}
              />
            </Form.Item>

            {hasServiceItems && (
              <Form.Item label="Service Account" required>
                <Select
                  showSearch
                  placeholder="Select Service Account"
                  optionFilterProp="label"
                  value={selectedServiceAcc?.acc_id}
                  options={serviceAccounts.map((a) => ({ label: a.acc_name, value: a.acc_id }))}
                  onChange={(val) => {
                    const acc = serviceAccounts.find((a) => a.acc_id === val);
                    SetSelectedServiceAcc(acc);
                  }}
                />
              </Form.Item>
            )}

            <Form.Item label="Previous Due">
              <InputField value={Number(prevDues).toFixed(2)} disabled />
            </Form.Item>

            <Form.Item label="Contact No">
              <InputField value={selectedSearchedCustomer?.contact_no} disabled />
            </Form.Item>

            <Form.Item label="Invoice No">
              <InputField value={footerValues.salesVoucherNumber} disabled />
            </Form.Item>

            <Form.Item label="Choose Employee">
              <SearchListAutoComplete
                entityType="employee"
                value={
                  selectedEmployee
                    ? {
                      sale_id: selectedEmployee,
                      display_text: lookups.employees.find((e) => e.employee_id === selectedEmployee)?.employee_name,
                    }
                    : null
                }
                optionsList={lookups.employees.map((e) => ({
                  sale_id: e.employee_id || null,
                  display_text: e.employee_name || null,
                  raw: e,
                }))}
                onSelect={(val) => {
                  if (val === "add_new") { setEmployeeDrawerOpen(true); return; }
                  setSelectedEmployee(val?.sale_id || null);
                  form.setFieldsValue({ employee_id: val?.sale_id || null });
                }}
                placeholder="Employee"
                showAddNew={true}
              />
            </Form.Item>

            <Form.Item label="Search Tags">
              <Select
                data-testid="roles-select"
                className="tag-multiselect"
                maxTagCount="responsive"
                mode="multiple"
                style={{ width: "100%" }}
                onChange={handletaggroup}
                value={selectedTags}
                placeholder="Select Tags"
                options={tags}
                popupRender={(menu) => (
                  <>
                    {menu}
                    <div style={{ display: "flex", justifyContent: "center", padding: 8, borderTop: "1px solid #f0f0f0" }}>
                      <Button type="link" onClick={() => setTagModal(true)}>+ Add New Tag</Button>
                    </div>
                  </>
                )}
              />
            </Form.Item>

            <Form.Item label="Delivery Type">
              <Select
                allowClear
                placeholder="None (Direct Sales)"
                value={deliveryType}
                onChange={(val) => {
                  setDeliveryType(val || null);
                  if (!val || val === "direct_sales") {
                    setDeliveryRouteId(null);
                    setPickupDate(null);
                    setDeliveryDate(null);
                  } else if (val === "onsite_delivery" && selectedSearchedCustomer?.default_delivery_route_id) {
                    setDeliveryRouteId(selectedSearchedCustomer.default_delivery_route_id);
                  }
                }}
                options={[
                  { label: "Direct Sales (No Delivery)", value: "direct_sales" },
                  { label: "Store Pickup", value: "store_pickup" },
                  { label: "Onsite Delivery", value: "onsite_delivery" },
                ]}
              />
            </Form.Item>

            {deliveryType === "onsite_delivery" && (
              <Form.Item label="Delivery Route">
                <Select
                  allowClear
                  placeholder="Select route (optional)"
                  value={deliveryRouteId}
                  onChange={(val) => setDeliveryRouteId(val || null)}
                  options={(deliveryRoutes || []).map((r) => ({ label: r.name, value: r.id }))}
                />
              </Form.Item>
            )}

            {deliveryType && deliveryType !== "direct_sales" && (
              <>
                <Form.Item label={deliveryType === "store_pickup" ? "Pickup Date" : "Delivery Date"}>
                  <DatePicker
                    style={{ width: "100%" }}
                    value={deliveryType === "store_pickup" ? (pickupDate ? dayjs(pickupDate) : null) : (deliveryDate ? dayjs(deliveryDate) : null)}
                    onChange={(d) => {
                      const val = d ? d.format("YYYY-MM-DD") : null;
                      if (deliveryType === "store_pickup") setPickupDate(val);
                      else setDeliveryDate(val);
                    }}
                    format="DD-MM-YYYY"
                  />
                </Form.Item>
                <Form.Item label="Delivery Notes">
                  <InputField
                    value={deliveryNotes}
                    onChange={(e) => setDeliveryNotes(e.target.value)}
                    placeholder="Notes (optional)"
                  />
                </Form.Item>
              </>
            )}

            {!isFieldHidden("Convert Currency") && (
              <Form.Item>
                <Checkbox
                  onChange={(e) => {
                    const checked = e.target.checked;
                    SetIsConvertCurrencyShow(checked);
                    if (!checked) {
                      handleFooterChange(null, "conversion_rate");
                      handleFooterChange(null, "conversion_currency");
                      setConversionRate(null);
                    }
                  }}
                >
                  Convert Currency
                </Checkbox>
              </Form.Item>
            )}
          </Flex>
        </Flex>

        {/* Currency Conversion Row */}
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{ flexDirection: !screens.md || !screens.xl ? "column" : "row", width: "100%", marginBottom: "24px" }}
        >
          {isConvertCurrencyShow && (
            <>
              <Flex vertical gap={10} style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}>
                <Form.Item label="Choose Currency">
                  <Select
                    showSearch
                    placeholder="Select Currency"
                    style={{ minWidth: 200 }}
                    options={getCurrencyCodeWithName().map((c) => ({
                      value: c.code,
                      label: `${c.currency} (${c.code})`,
                    }))}
                    onChange={async (toCurrency) => {
                      const rate = await convertCurrency(currency, toCurrency);
                      if (rate) {
                        handleFooterChange(rate, "conversion_rate");
                        handleFooterChange(toCurrency, "conversion_currency");
                        setConversionRate(rate);
                      }
                    }}
                  />
                </Form.Item>
              </Flex>
              <Flex vertical gap={10} style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}>
                <Form.Item label="Conversion Rate">
                  <InputField value={conversionRate} disabled />
                </Form.Item>
              </Flex>
            </>
          )}
        </Flex>
      </Form>

      {/* Help Drawer */}
      <Drawer title="Sales Entry Help" open={helpOpen} onClose={() => setHelpOpen(false)} width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
>
        <div style={{ lineHeight: 1.8 }}>
          <h2 style={{ fontSize: "18px", fontWeight: 600, marginBottom: "12px", marginLeft: "8px" }}>Sales Entry</h2>
          <p style={{ color: "#555", marginBottom: "16px", marginLeft: "8px" }}>
            The Sales Entry page is used to create and record customer sales transactions within the ERP system.
            It helps manage billing, inventory updates, accounts, and sales reporting in real time.
          </p>
          <div style={{ background: "#f5f5f5", padding: "14px", borderRadius: "8px", marginBottom: "16px" }}>
            <strong>Steps to Create Sales Entry</strong>
            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>Open <strong>Sales → Sales Entry</strong></li>
              <li>Select the customer</li>
              <li>Verify customer and invoice details</li>
              <li>Select sales account and employee if required</li>
              <li>Add products/items with quantity and rate</li>
              <li>Apply discounts or additional charges if needed</li>
              <li>Review totals and payment details</li>
              <li>Click <strong>Save</strong> to complete the transaction</li>
            </ol>
          </div>
          <div style={{ background: "#fafafa", border: "1px solid #eee", padding: "14px", borderRadius: "8px" }}>
            <strong>Important Notes</strong>
            <ul style={{ paddingLeft: "18px", marginTop: "10px", color: "#666" }}>
              <li>Customer selection is required before saving.</li>
              <li>Inventory stock updates automatically after sales entry.</li>
              <li>Invoice totals are affected by discounts and VAT settings.</li>
              <li>Ensure all entered quantities and prices are verified.</li>
            </ul>
          </div>
        </div>
      </Drawer>

      <div style={{ width: "100%", maxWidth: "1300px" }}>
        <InvoiceTable
          taxMode={taxMode}
          handleFooterChange={handleFooterChange}
          handleInputChange={handleInputChange}
          handleDeleteRow={handleDeleteRow}
          handleAddRow={handleAddRow}
          handleSaveDraftAndNavigate={handleSaveDraftAndNavigate}
          footerValues={footerValues}
          itemsList={itemsList}
          authInfo={authInfo}
          selectedSearchedCustomer={selectedSearchedCustomer}
          conversionRate={conversionRate}
          dueDate={dueDate}
          convertId={convertId}
          quoteId={quoteId}
          editId={editId}
          isEditMode={!!editId}
          isTatmeenProduct={isTatmeenProduct}
          isTatmeenUAE={isTatmeenUAE}
        />
      </div>

      <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
        <Button size="large" onClick={() => navigate(-1)} className="traic-button">Back</Button>
        {access_type === "WRITE" && (
          <Button type="primary" size="large" className="traic-button" onClick={submitForm} loading={loading} disabled={false}>
            Save
          </Button>
        )}
      </Flex>

      <CustomerDrawer
        open={customerDrawerOpen}
        onClose={() => setCustomerDrawerOpen(false)}
        authInfo={authInfo}
        onCreated={(customer) => {
          if (!customer) return;
          const customerObj = { ...customer, display_text: `${customer.acc_name} - ${customer.acc_code}` };
          setSelectedSearchedCustomer(customerObj);
          form.setFieldValue("search_customer", customerObj);
          dispatch(fetchCustomersBalance(customer.acc_id));
        }}
      />

      <EmployeeQuickDrawer
        open={employeeDrawerOpen}
        onClose={() => setEmployeeDrawerOpen(false)}
        onCreated={async (employee) => {
          if (!employee?.employee_id) return;
          const updated = await dispatch(fetchEmployees()).unwrap();
          const created = updated.find((e) => e.employee_id == employee.employee_id);
          if (!created) return;
          const option = { sale_id: created.employee_id, display_text: created.employee_name, raw: created };
          setSelectedEmployee(created.employee_id);
          form.setFieldsValue({ employee_id: created.employee_id });
          form.setFieldValue("employee_id", option);
          setEmployeeDrawerOpen(false);
        }}
      />

      <AddNewModal open={tagModal} title="Add Tag" onClose={() => setTagModal(false)}>
        <TagCreateForm
          authInfo={authInfo}
          onSuccess={async ({ groupId, createdName }) => {
            const res = await dispatch(fetchTagGroupFields("")).unwrap();
            const match = res.find(
              (t) => t?.raw?.field_name?.toLowerCase() === createdName.toLowerCase()
            );
            if (!match) { message.warning("Tag creation failed or tag not found"); setTagModal(false); return; }
            if (tag_field_id.includes(match.id)) { message.info("Tag already exists and is already selected"); setTagModal(false); return; }
            dispatch(setTagFeildNameid([...tag_field_id, match.id]));
            message.success("Tag added");
            setTagModal(false);
          }}
        />
      </AddNewModal>
    </div>
  );
};

export default CreateInvoiceForm;